var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgActionsClose = function SvgActionsClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.3 4 4 5.3l6.7 6.7L4 18.7 5.3 20l6.7-6.7 6.7 6.7 1.3-1.3-6.7-6.7L20 5.3 18.7 4 12 10.7 5.3 4Z"
  })));
};
export default SvgActionsClose;